module.exports = __webpack_public_path__ + "img/batting-cage.a427f9c2.svg";